const selectors = {
  getBusinessAccountResult: (state) => state.business.getBusinessAccountResult,
};

export default selectors;
